import { render, staticRenderFns } from "./ReservaCartaoList.vue?vue&type=template&id=0eb2d15d&scoped=true&"
import script from "./ReservaCartaoList.vue?vue&type=script&lang=js&"
export * from "./ReservaCartaoList.vue?vue&type=script&lang=js&"
import style0 from "./ReservaCartaoList.vue?vue&type=style&index=0&id=0eb2d15d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb2d15d",
  null
  
)

export default component.exports